import Alpine from "alpinejs";

export function renderSections(sections) {
	const patches = [];

	Object.entries(sections).forEach(([id, markup]) => {
		const selector = `[data-id="${id}"]`;

		const toReplace = document.querySelectorAll(selector);
		const toHTML = new DOMParser()
			.parseFromString(markup, "text/html")
			.querySelector(selector).outerHTML;

		toReplace.forEach((el) => {
			const patch = new Promise((resolve, reject) => {
				Alpine.morph(el, toHTML, {
					updated() {
						resolve(true);
					},
				});
				// Alpine.morph runs synchronously; resolve unconditionally so that
				// no-op morphs (rendered HTML identical to current DOM) don't hang.
				resolve(true);
			});

			patches.push(patch);
		});
	});

	return Promise.all(patches);
}
